import React, { useEffect } from 'react';
import { Button } from '@kudi-inc/dip';
import { BusinessIcon, MerchantIcon, WalletIcon } from 'assets/svgs';
import styles from './layout.module.scss';
import { useHistory } from 'react-router-dom';
import {formatCurrency} from 'libs';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import {merchantId} from 'store/actions/wallet-history';
import {
  fetchWalletBalance,
} from 'store/actions/dashboard';

const LogoSection = ({details, walletBalance}) => {
  let history = useHistory();
  const dispatch = useDispatch()
  
  useEffect(() => {
    fetchWalletBalance();
  }, [fetchWalletBalance]);
  return (
    <div className={styles.Header}>
      <div className={styles.Header_businessSection}>
        <BusinessIcon />
        <div className={styles.Header_businessSection_info}>
          <span className={styles.Header_businessSection_info_name}>
            {details?.businessName || '-'}
          </span>
          <span className={styles.Header_businessSection_info_phone}>
            {details?.merchantUser?.phoneNumber || '-'}
          </span>
        </div>
      </div>

      <div className={styles.Header_profileSection}>
        <div className={styles.Header_spacing}/>
        <div className={styles.Header_profileSection_info}>
          <span className={styles.Header_profileSection_info_name}>
            { details?.merchantUser?.firstName && details?.merchantUser?.lastName ? (`${details.merchantUser.firstName} ${details.merchantUser.lastName}`) : '-'}
          </span>
        </div>
      </div>
      <div className={styles.Header_walletBalanceSection}>
        <WalletIcon className={styles.Header_walletBalanceSection_icon} />
        <div className={styles.Header_walletBalanceSection_info}>
          <span className={styles.Header_walletBalanceSection_info_title}>
            Wallet Balance
          </span>
          <span className={styles.Header_walletBalanceSection_info_balance}>
            {formatCurrency(walletBalance)}
          </span>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ dashboard: { walletBalance }}) => ({ walletBalance });

export default connect(mapStateToProps, {fetchWalletBalance})(LogoSection);
